import { Component, OnInit } from '@angular/core';
import { FaqSectionModel, FaqSectionQuery, FaqSectionService, MemberQuery } from '@fgb/core';

import { Observable } from 'rxjs';

@Component({
  selector: 'fgbcl-faq-section',
  templateUrl: './faq-section.component.html',
  styleUrls: ['./faq-section.component.scss'],
})
export class FaqSectionComponent implements OnInit {
  constructor(
    private faqSectionQuery: FaqSectionQuery,
    private faqSectionService: FaqSectionService,
    private memberQuery: MemberQuery
  ) {}

  disabled = false;
  loading: Observable<boolean>;
  faqSections$: Observable<FaqSectionModel[]>;

  ngOnInit(): void {
    const userContext = this.memberQuery.getUserContext();

    this.faqSectionService.fetchFaqSection(+userContext.populationId, +userContext.lcid, userContext.clubId).subscribe();

    this.faqSections$ = this.faqSectionQuery.selectAll();

    this.loading = this.faqSectionQuery.selectLoading();
  }
}
